export default __webpack_public_path__ + "static/media/CV2.0d7a6809.png";